<template>
  <a-layout :style="{ height: '100vh' }">
    <a-layout-header :class="['header', `header-${this.theme}`]">
      <div :class="['logo', `logo-${this.theme}`]">
        <img v-if="appLogo != null" :src="appLogo" />
        <div class="appName">
          {{ appName || $t('应用编辑器') }}
        </div>
      </div>
      <div class="workbench single-line"></div>
      <Menu :tree="rootMenus" mode="horizontal" :theme="theme" :selectedKeys="selectedMenuKey" :inHeader="true" @select="handleHeaderMenuSelect" v-if="showHeaderMenu"></Menu>
      <div class="header-right">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <span style="font-size: 14px; font-weight: 600; margin-left: 10px;" :style="{ color: this.theme === 'dark' ? '#fff' : '#333' }" >{{ userInfo.name }}</span>
          <div style="height: 64px; width: 1px; margin-left: 15px;" :style="{ backgroundColor: this.theme === 'dark' ? '#fff' : '#ddd' }"></div>
        </div>
        <div style=" margin-left: 10px; display: flex; flex-direction: row; align-items: center;">
          <LanguageSwitcher :theme="theme" />
          <div style="height: 64px; width: 1px; margin-left: 10px;" :style="{ backgroundColor: this.theme === 'dark' ? '#fff' : '#ddd' }"></div>
        </div>
        <div style=" margin-left: 20px; cursor: pointer;">
          <a-icon type="poweroff" style="font-size: 16px;" :style="{ color: this.theme === 'dark' ? '#fff' : '#333' }" @click="handleLogout" />
        </div>
      </div>
    </a-layout-header>
    <a-layout>
      <a-layout-sider width="200" :class="[`menu-sider-${this.theme}`]" v-if="showSideMenu" style="overflow-y: auto; overflow-x: hidden;">
        <Menu :tree="sideMenus" :theme="theme" v-model="selectedMenuKey" mode="inline" :openKeys="openKeys" :readonly="!isAppConfigMode" @select="handleMenuItemSelect" @openChange="openChange"></Menu>
        <div style="text-align: center; margin-top: 10px; padding-bottom: 30px;" v-if="isAppConfigMode">
          <a-button type="primary" @click="handleAddFolder">{{ $t('新增目录') }}</a-button>
        </div>
      </a-layout-sider>
      <a-layout style="padding: 20px 16px 10px 16px; text-align: left;">
        <a-layout-content
          :style="{ background: '#fff', padding: 0, margin: 0, height: '100%' }"
        >
          <RouteView />
        </a-layout-content>
      </a-layout>
    </a-layout>
    <AppMenuFolderEditModal ref="folderModal" @ok="resetMenuTree" />
    <AppMenuPageEditModal ref="pageModal" @ok="resetMenuTree" />
    <AppMenuPageViewModal ref="pagereview" />
    <AppMenuPageTemplateModal ref="pagetemplate" />
    <AppMenuPageApiHeaderModal ref="header" />
  </a-layout>
</template>
<script>
import RouteView from './RouteView'
import Menu from './components/Menu'
import { mapActions } from 'vuex'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import { getUserMenus } from '@/api/user/user'
import { getFolderList, removeFolder } from '@/api/app/folder'
import { getAppInfo } from '@/api/app/app'
import AppMenuFolderEditModal from '@/views/app/modals/AppMenuFolderEditModal.vue'
import AppMenuPageEditModal from '@/views/app/modals/AppMenuPageEditModal.vue'
import { removePage } from '@/api/app/page'
import AppMenuPageViewModal from '@/views/app/modals/AppMenuPageViewModal.vue'
import { getDownloadUrl } from '@/api/file/file'
import AppMenuPageTemplateModal from '@/views/app/modals/AppMenuPageTemplateModal'
import RouteQueryMixins from '@/mixins/RouteQueryMixins'
import AppMenuPageApiHeaderModal from '@/views/app/modals/AppMenuPageApiHeaderModal.vue'

export default {
  components: {
    RouteView,
    Menu,
    LanguageSwitcher,
    AppMenuFolderEditModal,
    AppMenuPageEditModal,
    AppMenuPageViewModal,
    AppMenuPageTemplateModal,
    AppMenuPageApiHeaderModal
  },
  mixins: [RouteQueryMixins],
  data() {
    return {
      collapsed: false,
      selectedMenuKey: [],
      openKeys: [],
      menuTree: [],
      theme: 'light',
      layoutMode: '1', // 1:上菜单、下内容结构；2：左菜单、右内容结构；3：上主菜单、左次一级菜单、右内容结构
      selectedHeaderMenuKey: null,
      folders: null,
      appData: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
    rootMenus() {
      const menus = JSON.parse(JSON.stringify(this.menuTree))
      if (this.layoutMode === '1' || this.layoutMode === '3') {
        menus.forEach(m => {
          m.menuType = 'folder'
          if (this.layoutMode === '3') {
            m.tempchildren = m.children
            m.children = []
          }
        })
      }
      return menus
    },
    sideMenus() {
      if (this.layoutMode === '2') {
        return this.menuTree
      }
      if (this.layoutMode === '3') {
        const menu = this.menuTree.find(e => e.key == this.selectedHeaderMenuKey) || {}
        return menu.children || []
      }
      return []
    },
    showSideMenu() {
      return this.layoutMode === '2' || this.layoutMode === '3'
    },
    showHeaderMenu() {
      return this.layoutMode === '1' || this.layoutMode === '3'
    },
    isSystemMode() {
      return !this.mixinAppId
    },
    isAppConfigMode() {
      return this.mixinAppId && this.$route.query?.config
    },
    isAppReviewMode() {
      return this.mixinAppId && !this.$route.query?.config
    },
    appName() {
      if (!this.appData) {
        return null
      }
      return this.$store.getters.lang.isEnglish ? this.appData.nameEn || this.appData.name : this.appData.name
    },
    appLogo() {
      if (!this.appData?.logo?.length) {
        return null
      }
      return getDownloadUrl(this.appData.logo)
    }
  },
  watch: {
    '$route': {
      handler(newVal) {
        const route = newVal
        if (!(route.matched?.length)) {
          return
        }
        let matched = false
        for (const component of route.matched) {
          const vueComponent = component.instances?.default
          if (vueComponent != this) {
            continue
          }
          matched = true
          break
        }
        if (!matched) {
          return
        }
        this.$nextTick(() => {
          this.resetSelectedMenuKey()
        })
      },
      immediate: true,
      deep: true
    },
    'menuTree': {
      handler(newVal) {
        this.$nextTick(() => {
          this.resetSelectedMenuKey()
        })
      }
    }
  },
  created() {
    this.resetData()
    this.resetMenuTree()
  },
  methods: {
    ...mapActions(['logout', 'logoutApp']),
    resetData() {
      if (this.isSystemMode) {
        this.layoutMode = '2'
        this.theme = 'dark'
      } else {
        getAppInfo({ id: this.mixinAppId }).then(res => {
          if (res.code === 0) {
            this.appData = res.data
            if (this.isAppConfigMode) {
              this.layoutMode = '2'
              this.theme = 'dark'
            } else {
              this.layoutMode = res.data.banner
              this.theme = res.data.theme === '1' ? 'dark' : 'light'
            }
          }
        })
      }
    },
    resetMenuTree() {
      this.menuTree = []
      if (this.isSystemMode) {
        const menus = this.$store.getters.user.responseMenus || []
        // 过滤掉非系统菜单
        this.menuTree = menus.filter(e => e.appId == null || e.appId == '0')
      } else if (this.isAppConfigMode) {
        getFolderList({appId: this.mixinAppId}).then(res => {
          this.folders = res.data || []
          const buildTree = (folders, parentId) => {
            const roots = folders.filter(e => (parentId == null && (e.parentId == null || e.parentId == '0')) || (parentId != null && e.parentId == parentId)).map(e => ({
              key: e.id,
              name: e.name,
              menuType: 'folder',
              pages: e.pages
            }))
            roots.forEach(e => {
              let children = buildTree(folders, e.key) || []
              if (e.pages && e.pages.length > 0) {
                children = children.concat(e.pages.map(p => ({ key: p.id, name: p.name })))
              }
              e.children = children
            })
            return roots
          }
          this.menuTree = buildTree(this.folders, null)
        })
      } else if (this.isAppReviewMode) {
        getUserMenus({ appId: this.mixinAppId }).then(res => {
          const data = res.data || []
          this.menuTree = data
        })
      }
    },
    handleMenuItemSelect(item, action) {
      const findData = this.findFromTree(this.isAppConfigMode ? this.folders : this.menuTree, item.key)
      if (!findData) {
        return
      }
      if (item.menuType === 'folder') {
        if (action === 'edit') {
          this.$refs.folderModal.show(findData)
        } else if (action === 'add') {
          this.$refs.folderModal.show({ appId: findData.appId, parentId: findData.id, parentName: findData.name })
        } else if (action === 'addPage') {
          this.$refs.pageModal.show({ folderId: findData.id, folderName: findData.name })
        } else if (action === 'delete') {
          this.$confirm({
            title: this.$t('确认删除吗？'),
            onOk: () => {
              removeFolder([findData.id]).then(res => {
                if (res.code === 0) {
                  this.resetMenuTree()
                } else {
                  this.$message.error(res.message)
                }
              })
            }
          })
        } else if (action === 'folder') {
          if (this.layoutMode === '3') {
            this.handleHeaderMenuSelect(item)
          }
        }
      } else {
        if (action === 'select') {
          if (this.isSystemMode) {
            this.$router.push({ path: item.path, query: { ...this.$route.query } })
          } else if (this.isAppConfigMode) {
            const pageKey = this.buildPageKey(this.mixinAppId, findData.id)
            this.$router.push({ path: '/app/config/page', query: { ...this.$route.query, pageKey } })
          } else if (this.isAppReviewMode && findData.pageId) {
            const pageKey = this.buildPageKey(findData.appId, findData.pageId)
            this.$router.push({ path: `/app/review/page`, query: { ...this.$route.query, pageKey } })
          }
        } else if (action === 'edit') {
          this.$refs.pageModal.show(findData)
        } else if (action === 'config') {
          const pageKey = this.buildPageKey(this.mixinAppId, findData.id)
          this.$router.push({ path: '/app/config/page', query: { ...this.$route.query, pageKey } })
        } else if (action === 'review') {
          this.$refs.pagereview.show(findData)
        } else if (action === 'delete') {
          this.$confirm({
            title: this.$t('确认删除吗？'),
            onOk: () => {
              removePage([findData.id]).then(res => {
                if (res.code === 0) {
                  this.resetMenuTree()
                } else {
                  this.$message.error(res.message)
                }
              })
            }
          })
        } else if (action === 'folder') {
          if (this.layoutMode === '3') {
            this.handleHeaderMenuSelect(item)
          }
        } else if (action === 'template') {
          this.$refs.pagetemplate.show(findData)
        } else if (action === 'header') {
          this.$refs.header.show(findData)
        }
      }
    },
    findFromTree(tree, key) {
      const keyField = this.isAppConfigMode ? 'id' : 'key'
      if (!tree) {
        return null
      }
      let find = tree.find(e => e[keyField] === key)
      if (find) {
        return find
      }
      for (const t of tree) {
        if (this.isAppConfigMode) {
          find = this.findFromTree(t.pages, key)
          if (find) {
            return find
          }
        } else {
          find = this.findFromTree(t.children, key)
          if (find) {
            return find
          }
        }
      }
      return null
    },
    resetSelectedMenuKey() {
      if (this.menuTree.length === 0) {
        return
      }
      const { path, query } = this.$route
      const openKeys = []
      const find = list => {
        if (!list || list.length == 0) {
          return
        }
        const f = this.isSystemMode ? list.find(item => item.path === path) : this.isAppReviewMode ? list.find(item => item.pageId === this.mixinPageId) : list.find(item => item.key === this.mixinPageId)
        if (f) {
          return f
        }
        for (const item of list) {
          const subF = find(item.children)
          if (!subF) {
            continue
          }
          openKeys.push(item.key)
          return subF
        }
        return null
      }
      const selectedMenu = find(this.menuTree)
      if (!selectedMenu) {
        return
      }
      this.openKeys = openKeys
      this.selectedMenuKey = [selectedMenu.key]
      this.selectedHeaderMenuKey = openKeys[openKeys.length - 1]
    },
    openChange(openKeys) {
      this.openKeys = openKeys
    },
    handleHeaderMenuSelect(item) {
      const findData = this.findFromTree(this.isAppConfigMode ? this.folders : this.menuTree, item.key)
      if (!findData) {
        return
      }
      if ((this.isAppConfigMode && !findData.id) || (this.isAppReviewMode && !findData.pageId && !findData.children?.length)) {
        return
      }
      this.selectedHeaderMenuKey = item.key
      if (this.isAppConfigMode) {
        const pageKey = this.buildPageKey(this.mixinAppId, findData.id)
        this.$router.push({ path: '/app/config/page', query: { ...this.$route.query, pageKey } })
      } else if (this.isAppReviewMode && findData.pageId) {
        const pageKey = this.buildPageKey(this.mixinAppId, findData.pageId)
        this.$router.push({ path: '/app/review/page', query: { ...this.$route.query, pageKey } })
      } else if (this.isSystemMode) {
        this.$router.push({ path: findData.path, query: this.$route.query })
      }
    },
    handleAddFolder() {
      this.$refs.folderModal.show({ appId: this.mixinAppId })
    },
    handleLogout() {
      this.$confirm({
        title: this.$t('确认登出吗？'),
        onOk: () => {
          this.logout().then(res => {
            this.$router.replace({ path: '/user/login' })
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/components/theme.less";

.header {
  display: flex;
  flex-direction: row;
  position: relative;
}

.header-dark {
  // background-image: url('/public/image/banner/banner_bg.png');
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  background-color: @primary-color;
}

.header-light {
  background-color: #fff;
}

.logo {
  width: 200px;
  height: 100%;
  position: absolute;
  left: 0;
  text-align: center;
  padding: 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 0 0;
  overflow: hidden;
  padding: 10px;

  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .appName {
    font-size: 18px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.2em;
    max-height: 2.4em;
  }
}

.logo-dark {
  background: rgb(22, 39, 65);
  color: #ffffff;
}

.logo-light {
  background: #ffffff;
  color: #333333;
}

.workbench {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-left: 170px;
  float: left;
  max-width: 200px;
}

.single-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-right {
  position: absolute;
  right: 30px;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.menu-sider-dark {
  background-color: rgb(22, 39, 65);
}

.menu-sider-light {
  background-color: #ffffff;
}

</style>
